import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12c3fd44"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dashboard-card border-radius-20 pl-4 pr-4 pt-3 pb-3"
};
const _hoisted_2 = {
  class: "d-flex flex-row mb-3 justify-content-between align-items-center"
};
const _hoisted_3 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4"
}, null, -1));
const _hoisted_5 = {
  class: "mb-4"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-lg-6 col-12"
};
const _hoisted_8 = {
  class: "pl-4 pr-4"
};
const _hoisted_9 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_10 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_11 = {
  class: "fw-bold fsi-24"
};
const _hoisted_12 = {
  class: "fw-bold fsi-24"
};
const _hoisted_13 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_14 = {
  class: "pl-4 pr-4"
};
const _hoisted_15 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_16 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_17 = {
  class: "fw-bold fsi-24"
};
const _hoisted_18 = {
  class: "fw-bold fsi-24"
};
const _hoisted_19 = {
  class: "row mt-lg-4 mt-3"
};
const _hoisted_20 = {
  class: "col-lg-6 col-12"
};
const _hoisted_21 = {
  class: "pr-4"
};
const _hoisted_22 = {
  class: "pl-4 fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_23 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_24 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_25 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_26 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_27 = {
  class: "pl-4 pr-4"
};
const _hoisted_28 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_29 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_30 = {
  class: "fw-bold fsi-24"
};
const _hoisted_31 = {
  class: "fw-bold fsi-24"
};
const _hoisted_32 = {
  class: "row mt-lg-4 mt-3"
};
const _hoisted_33 = {
  class: "col-lg-6 col-12"
};
const _hoisted_34 = {
  class: "pr-4"
};
const _hoisted_35 = {
  class: "pl-4 fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_36 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_37 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_38 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_39 = {
  class: "col-lg-6 col-12"
};
const _hoisted_40 = {
  class: "pr-4"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pl-4 fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
}, "Owner")], -1));
const _hoisted_42 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_43 = {
  key: 0,
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_44 = {
  key: 1,
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_45 = {
  class: "row mt-lg-4 mt-3"
};
const _hoisted_46 = {
  class: "col-lg-6 col-12"
};
const _hoisted_47 = {
  class: "pr-4"
};
const _hoisted_48 = {
  class: "pl-4 fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_49 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_50 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_51 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_52 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_53 = {
  class: "pl-4 pr-4"
};
const _hoisted_54 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_55 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_56 = {
  class: "fw-bold fsi-24"
};
const _hoisted_57 = {
  class: "fw-bold fsi-24"
};
const _hoisted_58 = {
  class: "row mt-lg-4 mt-3"
};
const _hoisted_59 = {
  class: "col-lg-6 col-12"
};
const _hoisted_60 = {
  class: "pr-4"
};
const _hoisted_61 = {
  class: "pl-4 fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_62 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_63 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_64 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_65 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_66 = {
  class: "pl-4 pr-4"
};
const _hoisted_67 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_68 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_69 = {
  class: "fw-bold fsi-24"
};
const _hoisted_70 = {
  class: "d-flex w-100"
};
const _hoisted_71 = {
  style: {
    "white-space": "nowrap"
  },
  class: "mr-3 mr-sm-4"
};
const _hoisted_72 = {
  class: "info-item-value-sector"
};
const _hoisted_73 = {
  class: "info-item-value-sector text-right w-100",
  style: {
    "color": "rgba(217,50,50,0.9)"
  }
};
const _hoisted_74 = {
  style: {
    "white-space": "nowrap"
  }
};
const _hoisted_75 = {
  class: "info-item-value-sector",
  style: {
    "color": "rgba(56,158,71,0.9)"
  }
};
const _hoisted_76 = {
  class: "info-item-value-sector text-right w-100",
  style: {
    "color": "rgba(217,195,50,0.9)"
  }
};
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mt-4"
}, null, -1));
const _hoisted_78 = {
  class: "row mt-4"
};
const _hoisted_79 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_chart_block = _resolveComponent("chart-block");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.Overview')), 1)]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('farm.minerOverview.Address Balance')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_12, _toDisplayString($options.externalFormatFilPrice(_ctx.positionValue)), 1)])]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('farm.minerOverview.Available Balance')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_18, _toDisplayString($options.formatWalletFilPrice(_ctx.availableBalance)), 1)]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('farm.minerOverview.Initial Pledge')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_25, _toDisplayString($options.formatWalletFilPrice(_ctx.pledge)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('farm.minerOverview.Locked Rewards')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_31, _toDisplayString($options.formatWalletFilPrice(_ctx.lockedRewards)), 1)]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('farm.minerOverview.Average pledge')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_38, _toDisplayString($options.formatWalletFilPrice(_ctx.averagePledge)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_hoisted_41, _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_ctx.owner.toString().startsWith('0x00000') ? (_openBlock(), _createElementBlock("div", _hoisted_43, " -- ")) : (_openBlock(), _createElementBlock("div", _hoisted_44, " f0" + _toDisplayString(_ctx.owner), 1))]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('farm.minerOverview.Adjusted Power')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_50, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_51, _toDisplayString($options.formatBit(_ctx.qualityAdjPower, 2)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('farm.minerOverview.Raw Byte Power')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_56, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_57, _toDisplayString($options.formatBit(_ctx.rawBytePower, 2)), 1)]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('farm.minerOverview.Sector Size')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_63, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_64, _toDisplayString($options.formatBit(_ctx.sectorSize, null)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t('farm.minerOverview.Sector Status')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_69, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.sectorLive) + " " + _toDisplayString(_ctx.$t('farm.minerOverview.total')), 1), _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.sectorFaulty) + " " + _toDisplayString(_ctx.$t('farm.minerOverview.faults')), 1)]), _createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.sectorActive) + " " + _toDisplayString(_ctx.$t('farm.minerOverview.active')), 1), _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.sectorRecoveries) + " " + _toDisplayString(_ctx.$t('farm.minerOverview.recoveries')), 1)])])]),
    _: 1
  }, 8, ["loading"])])])]), _hoisted_77, _createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_createVNode(_component_chart_block, {
    height: "400px",
    showTools: false,
    option: $data.optionInterestRateMode
  }, null, 8, ["option"])])])])]);
}